import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames'; // 样式类合并

import { FormControl, InputBase, MenuItem, Select, Divider, SvgIcon } from '@material-ui/core';

import {Grid, Button, Slider} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

import Rating from '@material-ui/lab/Rating';
import hark from 'hark';

import { withRoomContext } from '../../RoomContext';
import * as settingsActions from '../../actions/settingsActions';
import * as meActions from '../../actions/meActions';

import * as appPropTypes from '.././appPropTypes';

import Logger from '../../Logger';

const logger = new Logger('VolumeSettings');

const styles = (theme) => ({
	root : {
		height        : '100%',
		display       : 'flex',
		flexDirection : 'column',
		alignItems    : 'center',
		overflowY     : 'auto',
		padding       : theme.spacing(1)
	},
	volumeContainer : {
		alignItems    : 'center',
		fontSize      : '1rem'
	},
	setting : {
		padding : theme.spacing(2)
	},
	formControl : {
		display : 'flex'
	},
	volumeBtn : {
		padding: theme.spacing(0.5, 1),
		borderRadius: theme.spacing(2),
		minWidth : theme.spacing(12.5),
		'&.blue'     :
		{
			backgroundColor	: '#2668FD',
			color:'#fff'
		},
		'&.grey'     :
		{
			backgroundColor	: '#DCEBFF',
			color:'#000'
		}
	}
});

const MediaSelect = withStyles((theme) => ({
	input: {
	  borderRadius : 4,
	  border       : '1px solid #ced4da',
	  padding      : theme.spacing(1, 1.5),
	  '&:focus': {
		borderColor: '#80bdff'
	  }
	}
  }))(InputBase);

class VolumeSettings extends React.PureComponent
{
	constructor(props)
	{
		super(props);

		this.state = {
			audioInputState: 1,      // 0 不可用; 1:可检测; 2:检测中
			inputVolume: 0,

			audioOutputState: 1      // 0 不可用; 1:可检测; 2:检测中
		};

		this._btnInputLabel = { 0: 'micTesting', 1: 'micTesting', 2: 'micStop' };
		this._btnOutputLabel = { 0: 'speakerTesting', 1: 'speakerTesting', 2: 'speakerStop' };

		this._harkStream = null;
		this._hark = null;

		this._inputAudio = new Audio('/sounds/test.wav');
		this._inputAudio.autoplay = true;
		this._inputAudio.loop = true;

		this._outputAudio = new Audio();
		this._outputAudio.loop = true;
		this._outputAudio.volume = this.props.settings.volume; // 输出音量默认值

		this._audioCtx = new AudioContext();

		const _srcAudio = this._audioCtx.createMediaElementSource(this._inputAudio);  // 创建源
		const _destAudio = this._audioCtx.createMediaStreamDestination();
		_srcAudio.connect(_destAudio);

		this._outputAudio.srcObject = _destAudio.stream;
	}

	async componentDidMount()
	{
		const { joined, me, settings } = this.props;

		let _audioInputDevices = [];
		let _audioOutputDevices = [];

		// 设置界面上的设备默认选择
		let	_inputDeviceId = settings.selectedAudioDevice;
		let	_outputDeviceId = settings.selectedAudioOutputDevice;

		// 设备列表
		const { audioDevices, audioOutputDevices } = me;

		_audioInputDevices = audioDevices ? Object.values(audioDevices).filter((v) => v.deviceId) : [];
		_audioOutputDevices = audioOutputDevices ? Object.values(audioOutputDevices).filter((v) => v.deviceId) : [];

		if(joined) {

			if (!_audioInputDevices && _audioInputDevices.length > 0) {

				_audioInputDevices = _audioInputDevices[0].deviceId;
			}

			if (!_outputDeviceId && _audioOutputDevices.length > 0) {

				_audioOutputDevices = _audioOutputDevices[0].deviceId;
			}
		} else {

			logger.debug(' componentDidMount() | calling enumerateDevices()');
			// 引入方法
			const {
				setAudioDevices,
				setAudioOutputDevices,
				settings,
				setSelectedAudioDevice,
				setSelectedAudioOutputDevice
			} = this.props;

			try {

				if (_audioInputDevices.length === 0 && _audioOutputDevices.length === 0) {
					// 通过 api 加载设备列表,并且初始化状态变量
					const _audioDevices = {};
					const _audioSpeakerDevices = {}

					const devices = await navigator.mediaDevices.enumerateDevices();

					for (const device of devices) {
						if (device.kind === 'audioinput') {

							_audioInputDevices.push(device);
							_audioDevices[device.deviceId] = device;

						} else if (device.kind === 'audiooutput') {

							_audioOutputDevices.push(device);
							_audioSpeakerDevices[device.deviceId] = device;

						}
					}
					setAudioDevices(_audioDevices);
					setAudioOutputDevices(_audioSpeakerDevices);
				}

				if (!_audioInputDevices && _audioInputDevices.length > 0) {
					_audioInputDevices = _audioInputDevices[0].deviceId;
				}

				if (!_outputDeviceId && _audioOutputDevices.length > 0) {
					_audioOutputDevices = _audioOutputDevices[0].deviceId;
				}

				logger.debug(`当前选择的设备: \n ${_inputDeviceId} \n ${_outputDeviceId}`);

				setSelectedAudioDevice(_inputDeviceId);
				setSelectedAudioOutputDevice(_outputDeviceId);

				/*
				const { selectedWebcam, resolution, frameRate } = settings;
				// 预加载摄像头设备
				await navigator.mediaDevices.getUserMedia({
					video: {
						deviceId: { ideal: selectedWebcam },
						...window.config.VIDEO_CONSTRAINS[resolution],
						frameRate
					}
				});
				*/
			} catch (error) {
				logger.error(' componentDidMount() [error:"%o"]', error);
			}
		}
	}

	/**
	 * 切换输入音频设备时调用的方法
	 */
	onChangeAudioInput = async () => {

		const { audioInputState } = this.state;

		const { settings } = this.props;
		const inputDeviceId = settings.selectedAudioDevice;

		// 如果当前状态是检测中切换音频设备
		if(audioInputState === 2) {

			const _deviceId = inputDeviceId;

			logger.debug('当前选择的输入设备:', _deviceId)
			// 	如果输入流存在则销毁
			if (this._harkStream != null) {
				let [track] = this._harkStream.getAudioTracks();
				track.stop();
				track = null;
				this._harkStream = null;
			}
			if (this._hark != null) {
				this._hark.stop();
			}

			this._harkStream = await navigator.mediaDevices.getUserMedia({
				audio: { deviceId: { ideal: _deviceId } }
			});

			this._hark = hark(this._harkStream, {
				play: false,
				interval: 10,
				threshold: -50, // 噪声阈值
				history: 100
			});

			this._hark.lastVolume = -100;

			this._hark.on('volume_change', (volume) => {
				// 仅在差异较大时更新
				if (Math.abs(volume - this._hark.lastVolume) > 0.5) {
					// 衰减计算: 请记住体积范围为-100 ... 0（dB）
					// 如果与上次保存的值相差较大，则衰减体积会变快，
					// 如果变化较小，则衰减体积会变慢。
					// 这可防止音量指示器在低电平时闪烁
					// volume : -74.90153503417969 lastVolume: -73.6783218383789 0.021596191296227404 -73.69991802967513
					if (volume < this._hark.lastVolume) {
						volume = this._hark.lastVolume - Math.pow((volume - this._hark.lastVolume) / (100 + this._hark.lastVolume), 2) * 10;
					}
					this._hark.lastVolume = volume;

					// 将 volume 转换为可以界面显示的数值(放大一倍)
					let _volume = (volume > -50 ? Math.round((volume + 100) / 10) : 0) * 1.8;

					this.setState({ inputVolume: _volume }, () => {

						_volume > 0 && logger.debug('当前音量大小', _volume);
					});
				}
			});
		}
	}

	/**
	 * 输入音频设备测试方法调用
	 */
    onCheckingAudioInput = async () => {

		const { audioInputState } = this.state;

		const { settings } = this.props;
		const inputDeviceId = settings.selectedAudioDevice;

		if (audioInputState === 1) {
			const _deviceId = inputDeviceId;

			logger.debug('当前选择的输入设备:', _deviceId)

			this._harkStream = await navigator.mediaDevices.getUserMedia({
				audio: { deviceId: { ideal: _deviceId } }
			});

			this._hark = hark(this._harkStream, {
				play: false,
				interval: 10,
				threshold: -50, // 噪声阈值
				history: 100
			});

			this._hark.lastVolume = -100;

			this._hark.on('volume_change', (volume) => {
				// 仅在差异较大时更新
				if (Math.abs(volume - this._hark.lastVolume) > 0.5) {
					// 衰减计算: 请记住体积范围为-100 ... 0（dB）
					// 如果与上次保存的值相差较大，则衰减体积会变快，
					// 如果变化较小，则衰减体积会变慢。
					// 这可防止音量指示器在低电平时闪烁
					// volume : -74.90153503417969 lastVolume: -73.6783218383789 0.021596191296227404 -73.69991802967513
					if (volume < this._hark.lastVolume) {
						volume = this._hark.lastVolume - Math.pow((volume - this._hark.lastVolume) / (100 + this._hark.lastVolume), 2) * 10;
					}
					this._hark.lastVolume = volume;

					// 将 volume 转换为可以界面显示的数值(放大一倍)
					let _volume = (volume > -50 ? Math.round((volume + 100) / 10) : 0) * 2.7;

					this.setState({ inputVolume: _volume }, () => {

						_volume > 0 && logger.debug('当前音量大小', _volume);
					});
				}
			});

			this.setState({ audioInputState: 2 });

		} else if (audioInputState === 2) {

			if (this._harkStream != null) {
				let [track] = this._harkStream.getAudioTracks();

				track.stop();
				track = null;

				this._harkStream = null;
			}

			if (this._hark != null) {
				this._hark.stop();
			}

			this.setState({ audioInputState: 1 })

		}
    };

	onCheckingAudioOutput = async () => {

		const { audioOutputState } = this.state;

		const { settings } = this.props;
		const outputDeviceId = settings.selectedAudioOutputDevice;

		if (audioOutputState === 1) {

			const _deviceId = outputDeviceId;

			logger.debug('当前选择的输出设备:', _deviceId)

			await this._outputAudio.setSinkId(_deviceId);

			await this._outputAudio.play();

			this.setState({ audioOutputState: 2 });

		} else if (audioOutputState === 2) {

			this._outputAudio.pause();

			this.setState({ audioOutputState: 1 })
		}
	}

	componentWillUnmount()
	{
		if (this._harkStream != null) {
			let [ track ] = this._harkStream.getAudioTracks();

			track.stop();
			track = null;

			this._harkStream = null;
		}

		if (this._hark != null) {
			this._hark.stop();
		}

		if (this._audioCtx) {
			this._audioCtx = null;
		}

		if (this._inputAudio) {
			this._inputAudio.srcObject = null;
		}

		if (this._outputAudio) {
			this._outputAudio.srcObject = null;
		}
	}

	render() {
		const {
			joined, setSelectedAudioDevice, setSelectedAudioOutputDevice, setVolume,
			roomClient, settings, classes, me
		} = this.props;

		const { audioInputState, inputVolume, audioOutputState } = this.state;

		const { audioDevices, audioOutputDevices } = me;
		const { selectedAudioDevice, selectedAudioOutputDevice } = settings;

		const _audioInputDevices = audioDevices ? Object.values(audioDevices).filter((v) => v.deviceId) : [];
		const _audioOutputDevices = audioOutputDevices ? Object.values(audioOutputDevices).filter((v) => v.deviceId) : [];

		const _inputDeviceId = selectedAudioDevice ? selectedAudioDevice : '';
		const _outputDeviceId = selectedAudioOutputDevice ? selectedAudioOutputDevice : '';

		// logger.debug(`当前浏览器信息: ${JSON.stringify(me.browser)}`);

		return (
			<React.Fragment>
				<form className={classes.setting} autoComplete='off'>
					<Grid container className={classes.volumeContainer} spacing={2}>
						{/** 扬声器测试 */}
						{ // 'audioOutputSupportedBrowsers' in window.config &&
						  // window.config.audioOutputSupportedBrowsers.includes(me.browser.name) &&
							<>
								<Grid item xs={2}>
									<FormattedMessage
										id             = 'settings.selectAudioOutput'
										defaultMessage = 'Select audio output device'
									/>
								</Grid>
								<Grid item xs={10}>
									<FormControl className={classes.formControl}>
										<Select
											value={_outputDeviceId}
											onChange={(event) =>
											{
												const _deviceId = event.target.value;

												if (_deviceId) {

													if(joined) {
														roomClient.changeAudioOutputDevice(_deviceId);
													} else {

														setSelectedAudioOutputDevice(_deviceId);
													}

													this.setState({
														outputDeviceId: _deviceId
													}, async () => {

														this._outputAudio.setSinkId(_deviceId);

														logger.debug(`输出音频切换至: ${_deviceId}`);
													})
												}
											}}
											displayEmpty
											name={<FormattedMessage
												id             = 'settings.audioOutput'
												defaultMessage = 'Audio output device'
											/>}
											autoWidth
											className={classes.selectEmpty}
											disabled={_audioOutputDevices.length === 0}
											input={<MediaSelect/>}
										>
											{ _audioOutputDevices.map((audioOutput, index) =>
											{
												return (
													<MenuItem
														key={index}
														value={audioOutput.deviceId}
													>
														{audioOutput.label}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>
								</Grid>
							</>
						}
						<Grid item xs={2}>
							<FormattedMessage
								id='settings.testOutputAudio'
								defaultMessage='Test speaker'
							/>
						</Grid>
						<Grid item xs={10}>
							<Grid container spacing={1} style={{ alignItems: 'center' }}>
								<Grid item>
									<img className={classes.imgIcon} src={`${window.app_base_path}/svg/settings/audio.svg`} />
								</Grid>
								<Grid item xs>
									<Slider
										disabled={_audioOutputDevices.length === 0}
										defaultValue={settings.volume * 100}
										onChange={(event, nextVolume) => {
										// 改变音量大小
										const _volume = (nextVolume / 100);

										this._outputAudio.volume = _volume;

										setVolume(_volume);

									}} aria-labelledby="continuous-slider" />
								</Grid>
								<Grid item>
									<Button variant="contained" size="small"  color="primary"
										disabled={_audioOutputDevices.length === 0}
										className={classnames(classes.volumeBtn, {
											blue : (audioOutputState < 2 ? true : false),
											grey : (audioOutputState === 2 ? true : false)
										})}
										onClick={this.onCheckingAudioOutput}>

											<FormattedMessage
												id={`label.${this._btnOutputLabel[audioOutputState]}`}
												defaultMessage='Detect microphone'
											/>

									</Button>
								</Grid>
							</Grid>
						</Grid>
					</Grid>

					<Divider style={{margin:'24px 4px'}} />

					<Grid container className={classes.volumeContainer} spacing={2}>
						<Grid item xs={2}>
							<FormattedMessage
								id='settings.selectAudio'
								defaultMessage='Select audio input device'
							/>
						</Grid>
						<Grid item xs={10}>
							<FormControl className={classes.formControl}>
								<Select
									value={_inputDeviceId}
									onChange={(event) =>
									{
										const _deviceId = event.target.value;
										if (_deviceId) {

											if (joined) {
												roomClient.updateMic({
													restart: true,
													newDeviceId: _deviceId
												});
											} else {

												setSelectedAudioDevice(_deviceId);
											}

											this.setState({
												inputDeviceId: _deviceId
											}, () => {
												this.onChangeAudioInput();
												logger.debug(`输入音频切换至:${_deviceId}`);
											})
										}
									}}
									displayEmpty
									name={<FormattedMessage
										id             = 'settings.audio'
										defaultMessage = 'Audio input device'
									/>}
									autoWidth
									className={classes.selectEmpty}
									disabled={_audioInputDevices.length === 0}
									input={<MediaSelect/>}
								>
									{ _audioInputDevices.map((audio, index) =>
									{
										return (
											<MenuItem
												key={index}
												value={audio.deviceId}
											>
												{audio.label === '' ? index + 1 : audio.label}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={2}>
							<FormattedMessage
								id='settings.testInputAudio'
								defaultMessage='Test Microphone'
							/>
						</Grid>
						<Grid item xs={10}>
							{/** 麦克风测试(标题、音频大小、检测按钮) */}
							<FormControl className={classes.formControl}>
								<Grid container spacing={1} style={{ alignItems: 'center' }}>
									<Grid item>
										<img className={classes.imgIcon} src={`${window.app_base_path}/svg/settings/mic.svg`} />
									</Grid>
									<Grid item xs style={{ overflow: 'hidden' }}>
										<Rating
											disabled={_audioInputDevices.length === 0}
											name="inputVolume"
											icon={<SvgIcon>
												<rect rx="2" height="50%" width="50%" y="25%" x="25%"/>
											</SvgIcon>}
											defaultValue={0} max={18} size="small" value={inputVolume} readOnly
										/>
									</Grid>
									<Grid item>
										<Button variant="contained" size="small" color="primary"
											disabled={_audioInputDevices.length === 0}
											className={classnames(classes.volumeBtn, {
												blue : (audioInputState < 2 ? true : false),
												grey : (audioInputState === 2 ? true : false)
											})}
											onClick={this.onCheckingAudioInput}>

												<FormattedMessage
													id={`label.${this._btnInputLabel[audioInputState]}`}
													defaultMessage='Detect microphone'
												/>

										</Button>
									</Grid>
								</Grid>
							</FormControl>
						</Grid>
					</Grid>
				</form>
			</React.Fragment>
		);
	}
}

VolumeSettings.propTypes =
{
	roomClient              : PropTypes.any.isRequired,
	settings                : PropTypes.object.isRequired,
	classes                 : PropTypes.object.isRequired,
	joined                  : PropTypes.bool.isRequired,
	me                      : appPropTypes.Me.isRequired,
};

const mapStateToProps = (state) =>
{
	return {
		joined    : state.room.joined,
		me       : state.me,
		settings : state.settings
	};
};

const mapDispatchToProps = {

	setSelectedAudioDevice        : settingsActions.setSelectedAudioDevice,
	setSelectedAudioOutputDevice  : settingsActions.setSelectedAudioOutputDevice,
	setVolume                     : settingsActions.setVolume,

	setAudioDevices               : meActions.setAudioDevices,
	setAudioOutputDevices         : meActions.setAudioOutputDevices
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.joined === next.room.joined &&
				prev.me === next.me &&
				prev.settings === next.settings
			);
		}
	}
)(withStyles(styles)(VolumeSettings)));